<form *ngIf="isQrEdition" [formGroup]="formQr" (ngSubmit)="saveQr()">
    <div class="tab-container scann-dni">
        <h1>Escanear QR</h1>

        <input #inputQr autocomplete="off" type="text" matInput formControlName="Qr" required cdkFocusInitial />
    </div>

    <div class="clearfix">
        <div class="pull-right">
            <button [disabled]="loadingQr" mat-button type="button" (click)="deleteQr()">
        Borrar
      </button>
            <button [disabled]="loadingQr" mat-button type="button" (click)="cancelQr()">
        Cancelar
      </button>
        </div>
    </div>
</form>
<form *ngIf="!isQrEdition" [formGroup]="form" (ngSubmit)="save()">
    <mat-tab-group>
        <mat-tab label="Detalle">
            <div class="tab-container">
                <mat-form-field class="margin-right-small margin-top-xx">
                    <input type="text" matInput placeholder="Tipo documento" formControlName="DocumentType" [matAutocomplete]="autDocumentType" required />
                    <mat-autocomplete #autDocumentType="matAutocomplete" [displayWith]="filterCompleteDocumentTypeFilter.displayFn">
                        <mat-option *ngFor="
                let documentType of filterCompleteDocumentTypeFilterOptions
                  | async
              " [value]="documentType">
                            {{ documentType.Name }}
                        </mat-option>
                    </mat-autocomplete>
                    <mat-error *ngIf="
              f.DocumentType.errors &&
              f.DocumentType.errors.validAutoCompleteSelect
            ">
                        Ingrese el tipo de documento
                    </mat-error>
                </mat-form-field>
                <mat-form-field class="margin-right-small margin-top-xx">
                    <input matInput placeholder="Número" formControlName="Number" />
                    <mat-error *ngIf="f.Number.errors && f.Number.errors.invalidNumber">
                        Ingrese el documento
                    </mat-error>
                </mat-form-field>
                <mat-form-field class="margin-right-small">
                    <input matInput placeholder="Apellido" formControlName="LastName" required />
                    <mat-error *ngIf="f.LastName.errors && f.LastName.errors.required">
                        Ingrese el apellido
                    </mat-error>
                </mat-form-field>
                <mat-form-field class="margin-right-small">
                    <input matInput placeholder="Nombre" formControlName="FirstName" />
                    <mat-error *ngIf="f.FirstName.errors && f.FirstName.errors.required">
                        Ingrese el nombre
                    </mat-error>
                </mat-form-field>
                <mat-form-field class="margin-right-small">
                    <input matInput formControlName="BirthDate" #dateOrder [matDatepicker]="picker" placeholder="Fecha nacimiento" required />
                    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                    <mat-datepicker #picker></mat-datepicker>
                    <mat-error *ngIf="f.BirthDate.errors && f.BirthDate.errors.required">
                        Ingrese la fecha de nacimiento
                    </mat-error>
                </mat-form-field>
                <mat-form-field class="margin-right-small">
                    <input type="text" matInput placeholder="Sexo" formControlName="Sex" [matAutocomplete]="autSex" />
                    <mat-autocomplete #autSex="matAutocomplete" [displayWith]="filterCompleteSexFilter.displayFn">
                        <mat-option *ngFor="let sex of filterCompleteSexFilterOptions | async" [value]="sex">
                            {{ sex.Name }}
                        </mat-option>
                    </mat-autocomplete>
                    <mat-error *ngIf="f.Sex.errors && f.Sex.errors.validAutoCompleteSelect">
                        Ingrese el sexo
                    </mat-error>
                </mat-form-field>
                <mat-form-field class="margin-right-small">
                    <mat-select placeholder="Relevancia" formControlName="Relevances" multiple>
                        <mat-select-trigger>
                            {{ f.Relevances.value?.length > 0 ? f.Relevances.value[0].Name : "" }}
                            <span *ngIf="f.Relevances.value?.length > 1" class="additional-selection">
                (+{{ f.Relevances.value.length - 1 }}
                {{ f.Relevances.value?.length === 2 ? "otra" : "otras" }})
              </span>
                        </mat-select-trigger>
                        <mat-option *ngFor="let relevancePatientFilter of relevancePatientFilters" [value]="relevancePatientFilter">
                            {{ relevancePatientFilter.Name }}
                        </mat-option>
                    </mat-select>
                    <mat-error *ngIf="f.Relevances.errors && f.Relevances.errors.required">
                        Seleccione una relevancia
                    </mat-error>
                </mat-form-field>
                <mat-form-field *ngIf="seePatientContactInfo" class="margin-right-small">
                    <input type="text" matInput placeholder="País" (input)="onCountryChange()" formControlName="Country" [matAutocomplete]="autCountry" />
                    <mat-autocomplete #autCountry="matAutocomplete" (optionSelected)="countrySelected($event.option.value)" [displayWith]="filterCompleteCountryFilter.displayFn">
                        <mat-option *ngFor="let country of filterCompleteCountryFilterOptions | async" [value]="country">
                            {{ country.Name }}
                        </mat-option>
                    </mat-autocomplete>
                </mat-form-field>
                <mat-form-field *ngIf="seePatientContactInfo" class="margin-right-small">
                    <input type="text" matInput placeholder="Provincia" (input)="onProvinceChange()" formControlName="Province" [matAutocomplete]="autProvince" />
                    <mat-autocomplete #autProvince="matAutocomplete" (optionSelected)="provinceSelected($event.option.value)" [displayWith]="filterCompleteProvinceFilter.displayFn">
                        <mat-option *ngFor="
                let province of filterCompleteProvinceFilterOptions | async
              " [value]="province">
                            {{ province.Name }}
                        </mat-option>
                    </mat-autocomplete>
                </mat-form-field>
                <mat-form-field *ngIf="seePatientContactInfo" class="margin-right-small">
                    <input type="text" matInput placeholder="Localidad" (input)="onLocalityChange($event.target.value)" formControlName="Locality" [matAutocomplete]="autLocality" />
                    <mat-autocomplete #autLocality="matAutocomplete" [displayWith]="filterCompleteLocalityFilter.displayFn">
                        <mat-option *ngFor="
                let locality of filterCompleteLocalityFilterOptions | async
              " [value]="locality">
                            {{ locality.Name }}
                        </mat-option>
                    </mat-autocomplete>
                </mat-form-field>

                <mat-form-field *ngIf="seePatientContactInfo" class="margin-right-small">
                    <input matInput placeholder="Código postal" formControlName="AddressCP" />

                    <mat-error *ngIf="f.AddressCP.errors && f.AddressCP.errors.invalidAddressCP">
                        El dato ingresado no es un código postal válido
                    </mat-error>
                </mat-form-field>

                <mat-form-field *ngIf="seePatientContactInfo" class="margin-right-small">
                    <input matInput placeholder="Calle" formControlName="AddressStreet" />
                </mat-form-field>
                <mat-form-field *ngIf="seePatientContactInfo" class="margin-right-small">
                    <input matInput placeholder="Nro" formControlName="AddressNumber" />
                </mat-form-field>
                <mat-form-field *ngIf="seePatientContactInfo" class="margin-right-small">
                    <input matInput placeholder="Piso" formControlName="Floor" />
                </mat-form-field>
                <mat-form-field *ngIf="seePatientContactInfo" class="margin-right-small">
                    <input matInput placeholder="Depto." formControlName="AddressDpto" />
                </mat-form-field>
                <mat-form-field *ngIf="seePatientContactInfo" class="margin-right-small">
                    <input matInput placeholder="Teléfono particular" formControlName="PersonalPhone" />
                    <mat-error *ngIf="
              f.PersonalPhone.errors &&
              f.PersonalPhone.errors.invalidOnePhoneRequired
            ">
                        Ingrese al menos un teléfono
                    </mat-error>
                </mat-form-field>
                <mat-form-field *ngIf="seePatientContactInfo" class="margin-right-small">
                    <input matInput placeholder="Teléfono laboral" formControlName="LaborPhone" />
                    <mat-error *ngIf="
              f.LaborPhone.errors && f.LaborPhone.errors.invalidOnePhoneRequired
            ">
                        Ingrese al menos un teléfono
                    </mat-error>
                </mat-form-field>
                <mat-form-field *ngIf="seePatientContactInfo" class="margin-right-small">
                    <input matInput type="text" placeholder="Celular" formControlName="CellPhone" />
                    <mat-error *ngIf="
              f.CellPhone.errors && f.CellPhone.errors.invalidCellPhoneNumber
            ">
                        El número ingresado no es válido
                    </mat-error>
                    <mat-error *ngIf="
              f.CellPhone.errors && f.CellPhone.errors.invalidOnePhoneRequired
            ">
                        Ingrese al menos un teléfono
                    </mat-error>
                    <mat-hint>ej: 11-1111-1111 (sin 15 al incio)</mat-hint>
                </mat-form-field>
                <mat-form-field *ngIf="seePatientContactInfo" class="margin-right-small">
                    <input matInput placeholder="Teléfono emergencia" formControlName="EmergencyPhone" />
                </mat-form-field>
                <mat-form-field *ngIf="seePatientContactInfo" class="margin-right-small">
                    <input matInput placeholder="Email" formControlName="Email" />
                    <mat-error *ngIf="f.Email.errors && f.Email.errors.email">
                        El mail ingresado no es válido
                    </mat-error>
                </mat-form-field>

                <mat-radio-group *ngIf="isReceptionSector" formControlName="ViewResultWeb">
                    <mat-radio-button class="margin-right-small" [value]="true">Acepta resultados en la Web</mat-radio-button>
                    <mat-radio-button [value]="false">NO acepta resultados en la Web</mat-radio-button>
                    <mat-error *ngIf="
              f.ViewResultWeb.errors &&
              f.ViewResultWeb.errors.invalidViewResultWeb
            ">
                        Debe ingresar si el paciente ve resultados en la web
                    </mat-error>
                </mat-radio-group>
                <mat-checkbox *ngIf="seePatientContactInfo" class="margin-right-small" formControlName="AcceptConfirm">Acepta confirmación</mat-checkbox>

                <h3 *ngIf="canViewMedicalPatientInfo" class="margin-top-small">
                    Relevancia médica
                </h3>
                <mat-divider *ngIf="canViewMedicalPatientInfo"></mat-divider>
                <mat-form-field *ngIf="canViewMedicalPatientInfo" class="margin-right-small">
                    <input type="number" matInput placeholder="Peso" formControlName="Weight" />
                </mat-form-field>
                <mat-form-field *ngIf="canViewMedicalPatientInfo" class="margin-right-small">
                    <input type="number" matInput placeholder="Altura (mts)" formControlName="Height" />
                </mat-form-field>

                <div>
                    <mat-checkbox *ngIf="canViewMedicalPatientInfo" class="margin-right-small" formControlName="Claustrophobia">Claustrofóbico</mat-checkbox>
                    <mat-checkbox *ngIf="canViewMedicalPatientInfo" class="margin-right-small" formControlName="Pacemaker">Marcapasos</mat-checkbox>
                    <mat-checkbox *ngIf="canViewMedicalPatientInfo" class="margin-right-small" formControlName="MetallicPart">Partes metálicas</mat-checkbox>
                    <mat-checkbox class="margin-right-small" formControlName="DisabilityPermanent">Disca. permatente (CUD)</mat-checkbox>
                    <mat-checkbox *ngIf="canViewMedicalPatientInfo" class="margin-right-small" formControlName="DisabilityTemporal">Disca. temporal/embarazo/bebé</mat-checkbox>

                    <br />
                    <h3 *ngIf="diagnositicFilters && diagnositicFilters.length > 0" class="margin-top-small">
                        Diagnóstico
                    </h3>
                    <mat-form-field *ngIf="diagnositicFilters && diagnositicFilters.length > 0" style="width: 100%"><br />
                        <mat-select placeholder="Diagnóstico" formControlName="Diagnostics" multiple>
                            <mat-select-trigger>
                                {{ f.Diagnostics.value?.length > 0 ? f.Diagnostics.value[0].Name : "" }}
                                <span *ngIf="f.Diagnostics.value?.length > 1" class="additional-selection">
                  (+{{ f.Diagnostics.value.length - 1 }}
                  {{ f.Diagnostics.value?.length === 2 ? "otro" : "otros" }})
                </span>
                            </mat-select-trigger>
                            <mat-option *ngFor="let diagnositicFilter of diagnositicFilters" [value]="diagnositicFilter">
                                {{ diagnositicFilter.Name }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>

                <app-text-editor-control *ngIf="diagnositicFilters && diagnositicFilters.length > 0" [content]="f.FreeDiagnostic.value" (onEditorChange)="freeDiagnosticChange($event)" elementId="freeDiagnostic"></app-text-editor-control>
            </div>
        </mat-tab>

        <mat-tab *ngIf="!canViewMedicalPatientInfo" label="Datos familiares">
            <div class="tab-container">
                <mat-form-field class="medium-width margin-right-medium">
                    <input matInput formControlName="MotherFirstName" placeholder="Nombre de la madre" />
                </mat-form-field>
                <mat-form-field class="medium-width">
                    <input matInput formControlName="MotherLastName" placeholder="Apellido de la madre" />
                </mat-form-field>
                <mat-form-field class="medium-width margin-right-medium">
                    <input matInput formControlName="FatherFirstName" placeholder="Nombre del padre" />
                </mat-form-field>
                <mat-form-field class="medium-width">
                    <input matInput formControlName="FatherLastName" placeholder="Apellido del padre" />
                </mat-form-field>
            </div>
        </mat-tab>

        <mat-tab *ngIf="!canViewMedicalPatientInfo" label="Datos de cobertura">
            <div class="tab-container">
                <mat-form-field class="medium-width margin-right-medium">
                    <input type="text" #entity matInput placeholder="Entidad" formControlName="Entity" [matAutocomplete]="autEntity" />
                    <mat-autocomplete #autEntity="matAutocomplete" [displayWith]="filterCompleteEntities.displayFn">
                        <mat-option *ngFor="let entity of filteredEntitiesOptions | async" [value]="entity">
                            {{ entity.Name }}
                        </mat-option>
                    </mat-autocomplete>
                </mat-form-field>

                <mat-form-field class="medium-width">
                    <input type="text" matInput placeholder="Plan" formControlName="Plan" [matAutocomplete]="autPlan" />
                    <mat-autocomplete #autPlan="matAutocomplete" [displayWith]="filterCompletePlans.displayFn">
                        <mat-option *ngFor="let plan of filteredPlansOptions | async" [value]="plan">
                            {{ plan.Name }}
                        </mat-option>
                    </mat-autocomplete>
                </mat-form-field>

                <mat-form-field class="medium-width">
                    <input type="text" matInput placeholder="Alícuota" formControlName="AliquotTax" [matAutocomplete]="autAliquotTax" />
                    <mat-autocomplete #autAliquotTax="matAutocomplete" [displayWith]="filterCompleteAliquotsTax.displayFn">
                        <mat-option *ngFor="let aliquotTax of filteredAliquotsTaxOptions | async" [value]="aliquotTax">
                            {{ aliquotTax.Name }}
                        </mat-option>
                    </mat-autocomplete>
                </mat-form-field>

                <mat-form-field class="medium-width">
                    <input type="text" matInput placeholder="Número de afiliado" formControlName="CredentialNumber" />
                </mat-form-field>
            </div>
        </mat-tab>
    </mat-tab-group>
    <div class="clearfix">
        <div class="pull-right">
            <mat-spinner *ngIf="loadingAction" matSuffix [diameter]="20"></mat-spinner>
            <button *ngIf="!loadingAction" mat-button type="submit">Guardar</button>
            <button *ngIf="!loadingAction" mat-button type="button" (click)="close()" cdkFocusInitial>
        Salir
      </button>
        </div>
    </div>
</form>
